
import Component from "vue-class-component"
import Vue from "vue"
import {Prop} from "vue-property-decorator"
import Axios from "axios"

export interface TrendHighlight {
  value: string
  color: string
}

@Component
export default class ApiChart extends Vue {
  @Prop({required: true})
  chartId: string

  @Prop({default: null})
  title: string

  @Prop({default: null})
  trendHighlight: TrendHighlight

  chartUrl: string | null = null

  async created() {
    Axios.get(`/api/charts/${this.chartId}`, {responseType: "blob"})
      .then(response => {
        this.chartUrl = URL.createObjectURL(
          new Blob([response.data], {type: "image/png"})
        )
      })
      .catch(reason => {
        console.error(`Failed loading chart: ${String(reason)}`)
        this.chartUrl = null
      })
  }
}
